// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Safety_TheComp__mEQ6G"};